$(document).ready(function(){
  console.log('test');
  $('.capacity_input_btn').click(async function(e) {
    // e.preventDefault();
    $('#capacity_input_imei_value').removeClass('capacity_input_imei_value_error');
    $("#capacity_input_btn_error_message p").remove();
    $('.capacity_input_btn').prop('disabled', true);
    $('.capacity_input_btn').text('');
    $('.capacity_input_btn').append('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
    const imeiValue = $('#capacity_input_imei_value').val();
    if (imeiValue.match(/[0-9]+/g) != imeiValue ){
        $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
		$("#capacity_input_btn_error_message").append("<p><i class=\"fa fa-exclamation-triangle\"></i>15桁の数字を入力してください。</p>");
        $('.capacity_input_btn').empty();
        $('.capacity_input_btn').prop('disabled', false);
        $('.capacity_input_btn').text('確認');
		return false;
	} else if (imeiValue.length < 15) {
        $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
		$("#capacity_input_btn_error_message").append("<p><i class=\"fa fa-exclamation-triangle\"></i>15桁の数字を入力してください。</p>");
		$('.capacity_input_btn').empty();
        $('.capacity_input_btn').prop('disabled', false);
        $('.capacity_input_btn').text('確認');
		return false;
    }
    
    if(imeiValue.length === 15) {
      // const gbsetImei = (await (await fetch(`https://okgffmskejwnx7qclibnv4tkfq0luohs.lambda-url.ap-northeast-1.on.aws/?imei=${imeiValue}`)).json()).isGbset;
      // console.log('gbsetImei',gbsetImei);
      
      $('.total-capacity-gb-display').text('-GB/-GB');
      $("#japan-tab-pane tbody.responsive-table__body").empty();
      $("#overseas-tab-pane tbody.responsive-table__body").empty();
      $("#used-tab-pane tbody.responsive-table__body").empty();
      $('#japan-tab-pane .progress-bar').css('width', '0%');
      $('#japan-tab-pane .progress').attr('aria-valuenow', '0');
      let japanTotalCapacity = 0;
      let japanTotalRemainingCapacity = 0;
      // if(gbsetImei) {
      const capacityResult = await (await fetch(`https://ihryksvq2jmuke2u3ha4wduxjq0ozmgu.lambda-url.ap-northeast-1.on.aws/?imei=${imeiValue}`)).json();
      if(capacityResult == null) {
        $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
        $("#capacity_input_btn_error_message").append("<p><i class=\"fa fa-exclamation-triangle\"></i>正しいIMEI番号を入力してください。</p>");
        $('.capacity_input_btn').empty();
        $('.capacity_input_btn').prop('disabled', false);
        $('.capacity_input_btn').text('確認');
      }

      capacityResult.japanCapacityList.forEach( capacity => {
        japanTotalCapacity += capacity.plan;
        japanTotalRemainingCapacity += capacity.surplusFlowbyte;
        if(capacity.status === 'IN_USING') {
          $("#japan-tab-pane tbody.responsive-table__body").append(`<tr class="responsive-table__row">
                      <td class="responsive-table__body__text responsive-table__body__text--name">
                          <span class="status-indicator status-indicator--active"></span>${capacity.countryName}
                      </td>
                      <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">${capacity.surplusFlowbyte}GB</td>
                      <td class="responsive-table__body__text responsive-table__body__text--plan">${capacity.plan}GB</td>
                      <td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
                  </tr>`);
        } else if(capacity.status === 'NOT_ACTIVATED') {
          $("#japan-tab-pane tbody.responsive-table__body").append(`<tr class="responsive-table__row">
                      <td class="responsive-table__body__text responsive-table__body__text--name">
                          <span class="status-indicator status-indicator--inactive"></span>${capacity.countryName}
                      </td>
                      <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">${capacity.surplusFlowbyte}GB</td>
                      <td class="responsive-table__body__text responsive-table__body__text--plan">${capacity.plan}GB</td>
                      <td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
                  </tr>`);
        }
      });

      capacityResult.overseasCapacityList.forEach( capacity => {
        if(capacity.status === 'IN_USING') {
          $("#overseas-tab-pane tbody.responsive-table__body").append(`<tr class="responsive-table__row">
          				<td class="responsive-table__body__text responsive-table__body__text--name">
          					<span class="status-indicator status-indicator--active"></span>${capacity.countryName}
          				</td>
                          <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">${capacity.surplusFlowbyte}GB</td>
          				<td class="responsive-table__body__text responsive-table__body__text--plan">${capacity.plan}</td>
          				<td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
          			</tr>`);
        } else if(capacity.status === 'NOT_ACTIVATED') {
          $("#overseas-tab-pane tbody.responsive-table__body").append(`<tr class="responsive-table__row">
          				<td class="responsive-table__body__text responsive-table__body__text--name">
          					<span class="status-indicator status-indicator--inactive"></span>${capacity.countryName}
          				</td>
                          <td class="responsive-table__body__text responsive-table__body__text--remaining-capacity">${capacity.surplusFlowbyte}GB</td>
          				<td class="responsive-table__body__text responsive-table__body__text--plan">${capacity.plan}</td>
          				<td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
          			</tr>`);
        }
      });

      capacityResult.usedList.forEach( capacity => {
          $("#used-tab-pane tbody.responsive-table__body").append(`<tr class="responsive-table__row">
          				<td class="responsive-table__body__text responsive-table__body__text--name">
          					<span class="status-indicator status-indicator--inactive"></span>${capacity.countryName}
          				</td>
          				<td class="responsive-table__body__text responsive-table__body__text--plan">${capacity.plan}</td>
          				<td class="responsive-table__body__text responsive-table__body__text--effective-date">${capacity.effectiveDate}</td>
          			</tr>`);
      });

      // } else {
      //   // ギガセット以外の端末
      //   $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
      //   $("#capacity_input_btn_error_message").append("<p><i class=\"fa fa-exclamation-triangle\"></i>ギガセット端末のMEI番号を入力してください。</p>");
      //   $('.capacity_input_btn').empty();
      //   $('.capacity_input_btn').prop('disabled', false);
      //   $('.capacity_input_btn').text('確認');
      // }

      $('.total-capacity-gb-display').text(`${Math.round(japanTotalRemainingCapacity*100)/100}GB/${japanTotalCapacity}GB`);
      const remainingCapacityRate = Math.round(japanTotalRemainingCapacity / japanTotalCapacity * 100);
      $('#japan-tab-pane .progress-bar').css('width', `${remainingCapacityRate}%`);
      $('#japan-tab-pane .progress').attr('aria-valuenow', remainingCapacityRate);
    }
    $('.capacity_input_btn').empty();
    $('.capacity_input_btn').prop('disabled', false);
    $('.capacity_input_btn').text('確認');
  });

  $("#capacity_input_imei_value").bind("blur", function() {
		let _textbox = $(this).val();
		check_imei_textbox(_textbox);
	});
});

function check_imei_textbox(str){
    $('#capacity_input_imei_value').removeClass('capacity_input_imei_value_error');
    $("#capacity_input_btn_error_message p").remove();
	$("#capacity_check_error_textbox p").remove();
	var _result = true;
	var _textbox = $.trim(str);

	if (_textbox.match(/[0-9]+/g) != _textbox ){
        $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
		$("#capacity_input_btn_error_message").append("<p><i class=\"fa fa-exclamation-triangle\"></i>15桁の数字を入力してください。</p>");
		_result = false;
	} else if (_textbox.length < 15) {
        $('#capacity_input_imei_value').addClass('capacity_input_imei_value_error');
		$("#capacity_input_btn_error_message").append("<p><i class=\"fa fa-exclamation-triangle\"></i>15桁の数字を入力してください。</p>");
		_result = false;
    }
	return _result;
}